// 合同信息
import { i18n } from '@/common/utils/i18n'
import ContractType from '@/pages/shopDetail/config/ContractType'
import {
  SIGN_CONTRACTOR_TYPE_LIST
} from '@/config-JP/sign/enums'
import ContractorTypeList from '@/pages/shopDetail/config/ContractorTypeList'
import PartyaTitle from '@/pages/shopDetail/config/PartyaTitle'
import { get } from 'lodash-es'

let filter = (list, target) => {
  return list.filter((item) => {
    return +item.value === +target
  })
}

const DeliveryType = {
  platform: 1, // 平台配送
  onself: 2, // 自配送
  both: 3 // 平台配送+自配送
}

function platformSupport (deliveryType) {
  let result = ''
  if (deliveryType === DeliveryType.onself) {
    result = i18n.gettext('不支持')
  } else {
    result = i18n.gettext('支持')
  }
  return result
}

function formatPercent (value) {
  let percentValue = ''
  if (value !== '') {
    percentValue = value + '%'
  }
  return percentValue
}

function onselfSupport (deliveryType) {
  let result = ''
  if (deliveryType === DeliveryType.platform) {
    result = i18n.gettext('不支持')
  } else {
    result = i18n.gettext('支持')
  }
  return result
}

export default (state) => {
  let contractInfo = get(state, 'currentContractorDetail.contractInfo', {})
  // let contractorInfo = get(state, 'currentContractorDetail.contractorInfo', {})
  return {
    title: i18n.gettext('合同信息'),
    content: [
      {
        title: i18n.gettext('合同类型'),
        content: ContractType.val2text(contractInfo.contractType)
      },
      {
        title: i18n.gettext('合同版本'),
        content: contractInfo.contractVersion
      },
      {
        title: i18n.gettext('合同编号'),
        label: contractInfo.contractId
      },
      {
        title: i18n.gettext('乙方名称'),
        label: `${contractInfo.partyaName} (${contractInfo.partyaNameAlph})`
      },
      {
        title: i18n.gettext('乙方注册地址邮编'),
        label: contractInfo.partyaPostCode
      },
      {
        title: i18n.gettext('乙方注册地址'),
        label: `${contractInfo.partyaAddr} (${contractInfo.partyaAddrAlph})`
      },
      {
        title: i18n.gettext('乙方邮箱'),
        label: contractInfo.partyaEmail
      },
      {
        title: i18n.gettext('乙方联系人'),
        label: `${contractInfo.partyaLastContact} ${contractInfo.partyaContact} (${contractInfo.partyaLastContactAlph} ${contractInfo.partyaContactAlph})`
      },
      {
        title: i18n.gettext('乙方联系人头衔'),
        label: PartyaTitle.val2text(contractInfo.partyaTitleType)
      },
      {
        title: i18n.gettext('乙方联系方式'),
        label: contractInfo.partyaPhone,
        isPhone: true
      },
      {
        title: i18n.gettext('平台配送'),
        content: platformSupport(contractInfo.deliveryType)
      },
      {
        title: i18n.gettext('平台配送佣金比例'),
        content: formatPercent(get(contractInfo, 'commissionJson.platform', ''))
      },
      {
        title: i18n.gettext('平台配送最低服务费'),
        content: contractInfo.deliveryMinRate && contractInfo.deliveryMinRate / 100
      },
      {
        title: i18n.gettext('自配送'),
        content: onselfSupport(contractInfo.deliveryType)
      },
      {
        title: i18n.gettext('自配送佣金比例'),
        content: formatPercent(get(contractInfo, 'commissionJson.onself', ''))
      },
      {
        title: i18n.gettext('商户主体类型'),
        content: contractInfo.contractorType ? filter(SIGN_CONTRACTOR_TYPE_LIST, contractInfo.contractorType)[0].text : ''
      }
    ]
  }
}
